import type {Schemas} from 'domainTypes/dto';
import type {ManifestationsCache} from '../types';
import {mapManifestationsDto} from './mapManifestationsDto';

export const mapManifestationsCacheDto = (
  dto: Schemas.ManifestationsDto,
  loadedEans: string[],
): ManifestationsCache => ({
  manifestationsByEan: Object.fromEntries(
    mapManifestationsDto(dto)
      .filter(manifestation => manifestation.ean)
      .map(manifestation => [manifestation.ean!, manifestation]),
  ),
  loadedEans,
});
